/*
 * jQuery-Calendar Plugin v1.1.0
 *
 * 2018 (c) Sebastian Knopf
 * This software is licensed under the MIT license!
 * View LICENSE.md for more information
 */

(function($) {
    $.fn.calendar = function(opts) {
        let elmCalend = this;
        var options = $.extend(
            {
                color: "#308B22",
                months: [
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                ],
                days: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
                event: {
                    initial: function(env) {},
                    onSelect: function(event) {}
                }
            },
            $.fn.calendar.defaults,
            opts
        );
        function dates_obj(obj) {
            this.obj = obj;
            return this.obj;
        }
        const dates = options.dates;
        const elmObjda = dates_obj(options.dates);
        let newdate = {};
        for (const key in dates) {
            if (dates.hasOwnProperty(key)) {
                const element = new dates_obj(dates[key].key);
                //dates[key].key={};
                let year;
                //console.log(element);
                for (let i = 0; i < element.length; i++) {
                    const elm = element[i];
                    const obj = elm.toString().split(" ");
                    year = obj[3];

                    if (options.dates[key][year] == undefined) {
                        options.dates[key][year] = {};
                    }
                    options.dates[key][year][
                        obj[0] + "_" + obj[1] + "_" + obj[2]
                    ] = elm;
                }
            }
        }
        elmCalend.each(function() {
            var currentYear, currentMonth, currentDay, currentCalendar;
            console.log(options);
            initCalendar($(elmCalend), options);
        });
        class joyCalendar {
            constructor(elm) {
                this.elm = $(elm);
            }
            close(selector) {
                try {
                    $(
                        this.elm[0].querySelector(".calendar-frame .joy-active")
                    ).removeClass("joy-active");
                } catch (e) {}
                try {
                    if (selector) {
                        $(selector).removeClass(selector);
                    }
                } catch (e) {}
            }

            day(day_item) {
                //console.log(document.querySelector())
                let day_to = $("[data-day='" + day_item + "']");
                function day() {}
                day.prototype.popover = function(strFunc, func, ft) {
                    (() => {
                        const elmPop = $(day_to.parents("[content-day]"));
                        if (strFunc instanceof Function) {
                            if (ft == undefined || ft == false) {
                                day_to.parents("[content-day]").innerHTML = "";
                            }
                            strFunc(day_to.parents("[content-day]"));
                        } else {
                            if (ft == undefined || ft == false) {
                                elmPop[0].querySelector(strFunc).innerHTML = "";
                            }
                            if (func instanceof Function) {
                                func(elmPop[0].querySelector(strFunc));
                            } else {
                                return elmPop[0].querySelector(strFunc);
                            }
                        }
                    })();
                };
                day.prototype.$ = day_to;
                day.prototype.isset = function() {
                    return (() => {
                        return (day_to[0].length = 0 ? false : true);
                    })();
                };
                //console.log(day_item.target)
                $daytrigger = () => {
                    return new day();
                };
                return $daytrigger();
            }
        }
        console.log();
        return new joyCalendar(this);
    };

    function initCalendar(wrapper, options) {
        var color = options.color;

        wrapper.addClass("joy-calendar").empty();

        var header = $("<header>").appendTo(wrapper);
        header.addClass("calendar-header");
        header.css({
            background: color,
            color: createContrast(color)
        });

        var buttonLeft = $("<span>").appendTo(header);
        buttonLeft.addClass("button").addClass("left");
        buttonLeft.html(" &lang; ");
        buttonLeft.bind("click", function() {
            currentCalendar = $(this).parents(".joy-calendar");
            selectMonth(false, options);
        });
        buttonLeft.bind("mouseover", function() {
            //$(this).css("background", createAccent(color, -20));
        });
        buttonLeft.bind("mouseout", function() {
            //$(this).css("background", color);
        });

        var headerLabel = $("<span>").appendTo(header);
        headerLabel.addClass("header-label");
        headerLabel.html(" Month Year ");
        headerLabel.bind("click", function() {
            currentCalendar = $(this).parents(".joy-calendar");
            selectMonth(
                null,
                options,
                new Date().getMonth(),
                new Date().getFullYear()
            );

            currentDay = new Date().getDate();
            triggerSelectEvent(options.event.initial);
        });

        var buttonRight = $("<span>").appendTo(header);
        buttonRight.addClass("button").addClass("right");
        buttonRight.html(" &rang; ");
        buttonRight.bind("click", function() {
            currentCalendar = $(this).parents(".joy-calendar");
            selectMonth(true, options);
        });
        buttonRight.bind("mouseover", function() {
            //$(this).css("background", createAccent(color, -20));
        });
        buttonRight.bind("mouseout", function() {
            //$(this).css("background", color);
        });

        var dayNames = $("<table>").appendTo(wrapper);
        var calendarFrame = $("<div>").appendTo(wrapper);
        calendarFrame.addClass("calendar-frame");

        headerLabel.click();
    }

    function selectMonth(next, options, month, year) {
        var tmp = currentCalendar
                .find(".header-label")
                .text()
                .trim()
                .split(" "),
            tmpYear = parseInt(tmp[1], 10);

        currentMonth =
            month ||
            (next
                ? tmp[0] === options.months[options.months.length - 1]
                    ? 0
                    : options.months.indexOf(tmp[0]) + 1
                : tmp[0] === options.months[0]
                ? 11
                : options.months.indexOf(tmp[0]) - 1);
        currentYear =
            year ||
            (next && currentMonth === 0
                ? tmpYear + 1
                : !next && currentMonth === 11
                ? tmpYear - 1
                : tmpYear);

        var calendar = createCalendar(currentMonth, currentYear, options),
            frame = calendar.frame();

        currentCalendar
            .find(".calendar-frame")
            .empty()
            .append(frame);
        currentCalendar.find(".header-label").text(calendar.label);
        currentCalendar.attr("data-month", parseInt(calendar.month) + 1);
        console.log();

        $(document).click(function(e) {
            const joy = $(e.target).parents(".joy-calendar");
            if (calendar.popover.active != null) {
                if (
                    calendar.popover.active !==
                    $(e.target).parents("[content-day]")[0]
                ) {
                    calendar.popover.active = true;
                }
            }

        });

        frame.on("click", "td .joy-days", function(e) {
            const joy = $(e.target).parents(".joy-calendar");
            const parent = this.parentNode;
            $("td").removeClass("selected");
            $(parent).addClass("selected");

            currentDay = $(".selected .joy-days").text();
            triggerSelectEvent(options.event.onSelect);
            const conteAct = parent.querySelector(".joy-popover");
            let activeOne = false;

            if (calendar.popover.active != null) {
                if(calendar.popover.active != true){
                    if (
                        conteAct ===
                        calendar.popover.active.querySelector(".joy-popover")
                    ) {
                        activeOne = true;
                    }
                    calendar.popover.active
                        .querySelector(".joy-popover")
                        .classList.remove("joy-active");
                }else{
                    const joyActi=joy[0].querySelectorAll(".joy-popover.joy-active")
                    for (const key in joyActi) {
                        if (joyActi.hasOwnProperty(key)) {
                            const element = joyActi[key];
                            element.classList.remove("joy-active")
                            console.log(element);
                        }
                    }
                }

            }
            setTimeout(function() {
                if (activeOne == false) {
                    conteAct.classList.add("joy-active");
                    calendar.popover.active = parent;
                } else {
                    activeOne = false;
                    calendar.popover.active = null;
                }
            }, 100);
        });
        const events = options.event;

        if (events.popover) {
            function methodsPop(evt) {
                $(evt[1])[evt[0]](evt[2]);
            }
            const methods = events.popover.methods;
            let names = events.popover.methods.names;
            for (const key in methods) {
                if (methods.hasOwnProperty(key)) {
                    const element = methods[key];
                    const nameEvent = key.split("_");
                    let name;
                    switch (nameEvent[0]) {
                        case "ready":
                            element();
                            break;

                        default:
                            if (nameEvent[0] != "names") {
                                //console.log(nameEvent);
                                for (const kna in names) {
                                    if (names.hasOwnProperty(kna)) {
                                        const elmNa = names[kna];
                                        const indexNa = elmNa.indexOf(
                                            nameEvent[1]
                                        );
                                        //console.log(elmNa.indexOf(nameEvent[1]),kna);
                                        if (indexNa > -1) {
                                            name = names[kna][indexNa];
                                            //console.log();
                                            if (kna == "class") {
                                                methodsPop([
                                                    nameEvent[0],
                                                    "." + name,
                                                    element
                                                ]);
                                            }
                                        }
                                    }
                                }
                            }

                            break;
                    }
                }
            }
        }
    }

    function createCalendar(month, year, options) {
        var currentDay = 1,
            daysLeft = true,
            startDay = new Date(year, month, currentDay).getDay(),
            lastDays = [
                31,
                (year % 4 == 0 && year % 100 != 0) || year % 400 == 0 ? 29 : 28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ],
            calendar = [];

        var i = 0;
        while (daysLeft) {
            calendar[i] = [];

            for (var d = 0; d < 7; d++) {
                if (i == 0) {
                    if (d == startDay) {
                        calendar[i][d] = currentDay++;
                        startDay++;
                    }
                } else if (currentDay <= lastDays[month]) {
                    calendar[i][d] = currentDay++;
                } else {
                    calendar[i][d] = "";
                    daysLeft = false;
                }

                if (currentDay > lastDays[month]) {
                    daysLeft = false;
                }
            }

            i++;
        }

        var frame = $("<table>").addClass("current");
        frame.append(
            "<thead><th>" + options.days.join("</th><th>") + "</th></thead>"
        );
        var frameBody = $("<tbody>").appendTo(frame);
        let con = 0;
        let rowsKey = 0;
        let popover = null;
        for (var j = 0; j < calendar.length; j++) {
            var frameRow = $("<tr>").appendTo(frameBody);

            $.each(calendar[j], function(index, item) {
                const events = options.event;
                const date = new Date(year, month, item).toString().split(" ");
                const days = date[0] + "_" + date[1] + "_" + date[2];

                const frameInse = $("<td>").appendTo(frameRow);
                const frameIday = $("<span>").appendTo(frameInse);
                const fday = $("<span>").appendTo(frameIday);

                //frameIday[0].setAtribute("onclick","popover")

                fday.text(item);
                //console.log(frameIday[0])
                if (typeof item == "number") {
                    fday.addClass("joy-day");
                    fday.attr("data-day", item);
                    frameInse.attr("content-day", "");

                    new Date().getDate().toString();

                    if (new Date().getMonth() == month) {
                        if (
                            parseInt(new Date().getDate().toString()) <=
                            parseInt(item)
                        ) {
                            frameIday.addClass("joy-days");
                        } else {
                            frameIday.addClass("joy-days_disabled");
                        }
                    } else if (
                        parseInt(new Date().getMonth()) < parseInt(month)
                    ) {
                        frameIday.addClass("joy-days");
                    } else if (
                        parseInt(new Date().getMonth()) > parseInt(month)
                    ) {
                        frameIday.addClass("joy-days_disabled");
                    }

                    //console.log(options.dates)
                    for (const key in options.dates) {
                        if (options.dates.hasOwnProperty(key)) {
                            const x = options.dates[key];
                            if (x[year.toString()]) {
                                if (x[year.toString()][days]) {
                                    //console.log(x.class);
                                    frameInse.addClass(x.class);

                                    /*if (x.popover) {
                                        const p = x.popover;
                                        let posit = null;
                                        if (p.rowsKey instanceof Array) {
                                            posit =p.rowsKey.indexOf(rowsKey);
                                        } else if (p.rowsKey instanceof Object) {
        
                                        }
                                        //console.log(posit)
                                        rowsKey++;
                                    }*/
                                }
                            }
                        }
                    }

                    if (events.popover) {
                        popover = {};
                        const eRows = events.popover.rows;
                        const p_todo = events.popover;
                        if (eRows instanceof Array) {
                            //aquí codigo de rows template seleccionado del dates
                        }

                        const joypopover = $("<div>").appendTo(frameInse);
                        const popover_conte = $("<div>").appendTo(joypopover);
                        popover_conte.addClass("joy-popover-content tooltip");
                        if (p_todo.template) {
                            $(p_todo.template.clone()).appendTo(popover_conte);
                        }

                        if (p_todo.style != false) {
                            joypopover.addClass("joy-popover");
                            popover_conte.addClass("joy-tooltip");
                        }
                        if (p_todo.class) {
                            joypopover.addClass(p_todo.class);
                        }

                        try {
                            popover["all"] = function() {};
                            popover["active"] = null;
                        } catch (error) {}
                    }
                }
            });
        }

        $("td:empty", frame).addClass("disabled");
        if (currentMonth === new Date().getMonth()) {
            $("td", frame)
                .filter(function() {
                    const day = $(this);

                    return (
                        $(day[0].childNodes[0]).text() ===
                        new Date().getDate().toString()
                    );
                })
                .addClass("today");
        }

        return {
            frame: function() {
                return frame.clone();
            },
            popover: popover,
            label: options.months[month] + " " + year,
            month: month
        };
    }

    function triggerSelectEvent(event) {
        var date = new Date(currentYear, currentMonth, currentDay);

        var label = [];
        label[0] = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        label[1] =
            date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
        label[2] = date.getFullYear();

        if (event != undefined) {
            event({ date: date, label: label.join("/") });
        }
    }

    function createContrast(color) {
        if (color.length < 5) {
            color += color.slice(1);
        }

        return color.replace("#", "0x") > 0xffffff ? "#222" : "#fff";
    }

    function createAccent(color, percent) {
        var num = parseInt(color.slice(1), 16),
            amt = Math.round(2.55 * percent),
            R = (num >> 16) + amt,
            G = ((num >> 8) & 0x00ff) + amt,
            B = (num & 0x0000ff) + amt;
        return (
            "#" +
            (
                0x1000000 +
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            )
                .toString(16)
                .slice(1)
        );
    }
})(jQuery);
